export default {
    tracking: {
        pixelUrls: {
            adTrackingUrl: '/sp/',
            clickProductCard: '/trk/commerce:click_product_card',
            clickShoppingCart: '/trk/commerce:click_shopping_cart',
            clickShoppingBag: '/trk/commerce:click_shopping_bag',
            dismissProductSummary: '/trk/commerce:dismiss_product_summary',
            clickUnitOptionSummary: '/trk/commerce:click_unit_option_summary',
            clickUnitOptionFull: '/trk/commerce:click_unit_option_full',
            clickMoreDescription: '/trk/commerce:click_more_description',
            clickProductDescriptionPageLink: '/trk/commerce:click_pdp_link',
            clickAddToCart: '/trk/commerce:click_add_to_cart',
            clickIncreaseInCartClick: '/trk/commerce:click_increase_in_cart',
            clickDecreaseInCartClick: '/trk/commerce:click_decrease_in_cart',
            clickRemoveInCartClick: '/trk/commerce:click_remove_in_cart',
            clickCheckout: '/trk/commerce:click_checkout',
            clickShopPay: '/trk/commerce:click_shop_pay',
            engagementClickCta: '/trk/engagement:click_cta',
            engagementClickCreator: '/trk/engagement:click_creator',
            engagementCreateCtaImpression: '/trk/engagement:create_cta_impression',
            engagementWatchVideo: '/trk/engagement:watch_video',
            feedCreateEmbedInstance: '/trk/feed:create_embed_instance',
            feedClickVideo: '/trk/feed:click_video',
            feedCreateFeedImpression: '/trk/feed:create_feed_impression',
            feedCreateThumbnailImpression: '/trk/feed:create_thumbnail_impression',
            feedScrollVideos: '/trk/feed:scroll_videos',
            feedScrollEndVideos: '/trk/feed:scroll_end_videos',
            playerClickShareVideo: '/trk/engagement:click_share_video',
            playerShareVideo: '/trk/engagement:share_video',
            videoPlayerClickExitFullscreen: '/trk/video_player:click_exit_fullscreen',
            videoPlayerClickFullscreen: '/trk/video_player:click_fullscreen',
            videoPlayerClickNotInterested: '/trk/video_player:click_not_interested',
            videoPlayerClickPause: '/trk/video_player:click_pause',
            videoPlayerClickReportVideo: '/trk/video_player:click_report_video',
            videoPlayerDismiss: '/trk/video_player:dismiss',
            videoPlayerMute: '/trk/video_player:mute',
            videoPlayerNextVideo: '/trk/video_player:next_video',
            videoPlayerPrevVideo: '/trk/video_player:prev_video',
            videoPlayerResume: '/trk/video_player:resume',
            videoPlayerStartVideo: '/trk/video_player:start_video',
            videoPlayerUnmute: '/trk/video_player:unmute',
            videoPlayerViewDetails: '/trk/video_player:view_details',
            videoPlayerDismissDetails: '/trk/video_player:dismiss_details',
            videoPlayerEnterPIP: '/trk/video_player:pip_enter',
            videoPlayerExitPIP: '/trk/video_player:pip_exit',
            videoPlayerFailedPIP: '/trk/video_player:pip_failed',
            commerceClickBuy: '/trk/commerce:click_buy',
            commerceClickConfirmPaymentIntent: '/trk/commerce:click_confirm_payment_intent',
            commerceConfirmPaymentIntent: '/trk/commerce:confirm_payment_intent',
            commerceClickPlaceOrder: '/trk/commerce:click_place_order',
            commerceClickUpdateOrder: '/trk/commerce:click_update_order',
            commerceClickCancelOrder: '/trk/commerce:click_cancel_order',
            commercePaymentError: '/trk/commerce:payment_error',
        },
    },
};
